import _extends from "@babel/runtime-corejs3/helpers/extends";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import * as _ from "../util/lodash";
var _sizes = {
  X1: 'mini',
  X2: 'tiny',
  X3: 'small',
  X4: 'medium',
  X5: 'large',
  X6: 'big',
  X7: 'huge',
  X8: 'massive'
};

var sizes = _extends({}, _sizes);

sizes.ALL = _valuesInstanceProperty(_).call(_, _sizes);
sizes.BASE = _sizes;
sizes.SMALL = sizes.S = sizes.X3;
sizes.MEDIUM = sizes.M = sizes.X4;
sizes.LARGE = sizes.L = sizes.X5;
sizes.S_M_L = [sizes.SMALL, sizes.MEDIUM, sizes.LARGE];
export default sizes;
//# sourceMappingURL=sizes.js.map